import { DateTimeField } from "components/fields/DateFormatField";
import { OrderReferenceField } from "components/fields/OrderReferenceField";
import { SelectEnumField } from "components/fields/SelectEnumField";
import { MyDatagrid } from "components/HistoryGrid/Grid";
import { createCellStyle } from "components/HistoryGrid/utils";
import { envSettings } from "core/EnvSettings";
import { PalletType } from "entities/PalletType";
import React from "react";
import { FunctionField, NumberField, ReferenceField, TextField } from "react-admin";

export const PalletHistoryGrid = ({ nextForRecordId, ...props }) => {
	const cellStyle = createCellStyle(props.data, nextForRecordId, ["updated_at", "updated_by_name"]);

	return (
		<MyDatagrid {...props} cellStyle={cellStyle}>
			{/* History metadata */}
			<TextField source="updated_by_name" label="tab.pallet_history.updated_by" sortable={false} />
			<DateTimeField source="updated_at" label="tab.pallet_history.updated_at" sortable={false} />

			{/* Order columns follow PalletsGrid order */}
			<TextField source="sscc" label="tab.pallets.sscc" sortable={false} />
			<TextField source="gtin" label="tab.pallets.gtin" sortable={false} />

			<DateTimeField
				source="production_datetime"
				label="tab.pallets.production_datetime"
				sortable={false}
			/>
			<DateTimeField
				source="expiration_datetime"
				label="tab.pallets.expiration_datetime"
				sortable={false}
			/>

			<NumberField source="quantity" label="tab.pallets.quantity" sortable={false} />
			<NumberField source="net_weight" label="tab.pallets.weight_net" sortable={false} />

			<SelectEnumField
				source="type"
				enumName="pallet_type"
				enumObj={PalletType}
				label="tab.pallets.type"
				sortable={false}
			/>

			{envSettings.REACT_APP_FF_STORAGE_MODULE ? (
				<ReferenceField
					source="storage_place_id"
					reference="storage-places-lookup"
					label="tab.pallets.storage_place_id"
					sortable={false}
					link={false}
				>
					<TextField source="address" />
				</ReferenceField>
			) : (
				<NumberField source="area_id" label="tab.pallets.area_id" sortable={false} />
			)}

			<TextField source="weight_unit_code" label="tab.pallets.weight_unit_code" sortable={false} />
			<NumberField
				source="number_of_pallet"
				label="tab.pallets.number_of_pallet"
				sortable={false}
			/>
			<NumberField
				source="total_number_of_pallet"
				label="tab.pallets.total_pallets"
				sortable={false}
			/>

			<TextField source="ext_id" label="tab.pallets.external_id" sortable={false} />
			<TextField source="product_number" label="tab.pallets.product_number" sortable={false} />
			<TextField source="product_name" label="tab.pallets.product_name" sortable={false} />

			<TextField source="ceel_number" label="tab.pallets.ceel_number" sortable={false} />
			<TextField source="batch_number" label="tab.pallets.batch_number" sortable={false} />
			<TextField source="lot_number" label="tab.pallets.lot_number" sortable={false} />
			<TextField source="packing_station" label="tab.pallets.packing_station" sortable={false} />

			<FunctionField
				source="is_t1"
				label="tab.pallets.is_t1"
				render={(record) => (record.is_t1 ? "YES" : "NO")}
				sortable={false}
			/>

			{/* Reference fields */}
			<OrderReferenceField source="order_id" label="tab.pallets.incoming_order" />
			<OrderReferenceField source="reserved_order_id" label="tab.pallets.reserved_order" />
		</MyDatagrid>
	);
};
